{
	"id": 7508,
	"moduleNumber": 8,
	"title": "Ethical Decision Making for the Professional Educator",
	"subtitle": "Synthesize ethical decision-making principles across professional practice scenarios.",
	"kgNodeId": "module-8",
	"moduleKind": "lesson",
	"moduleKindLabel": "Lesson",
	"summary": "This module contains one scenario with three different outcomes and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
	"estimatedDurationMinutes": 45,
	"activityCount": 1,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
